import { motion } from "framer-motion";
import { FC } from "react";

export interface SkeletonLoaderProps {
  count?: number;
  className?: string;
}

const SkeletonCard: FC = () => (
  <div className="animate-pulse">
    <div className="aspect-w-5 aspect-h-4 rounded-2xl bg-neutral-200 dark:bg-neutral-700" />
    <div className="mt-4 h-5 w-3/4 mx-auto rounded-lg bg-neutral-200 dark:bg-neutral-700" />
  </div>
);

const SkeletonLoader: FC<SkeletonLoaderProps> = ({
  count = 4,
  className = "",
}) => {
  return (
    <motion.div
      className={`grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 ${className}`}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </motion.div>
  );
};

export default SkeletonLoader;
